<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
  <g>
    <rect width="16" height="16" fill="none"/>
    <rect class="filled" x="2.797" y="6.875" width="10.407" height="2.25" fill="#035ce0"/>
  </g>
</svg>
